import { Button, Flex, Typography } from 'antd'
import React from 'react'
import { TimeAgo } from '../time-ago'
import clsx from 'clsx'
import { FileOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { ChatMessageProps } from './chat'
import { stripStateBlocks } from '../../prompts/state-message'

export function ChatMessage({
    role,
    content,
    createdAt,
    className,
    type = 'text',
    mediaUrl,
}: ChatMessageProps & { className?: string }) {
    const { t } = useTranslation()
    const color = role === 'assistant' ? 'bg-accent/40 rounded-bl-md' : 'bg-bubble-user rounded-br-md'
    const displayContent = role === 'assistant' ? stripStateBlocks(content) : content

    return (
        <Flex
            align={role === 'user' ? 'end' : 'start'}
            vertical
        >
            <div className={clsx(`shadow p-4 rounded-3xl sm:max-w-[60%] max-w-[80%] min-w-[145px]`, color, className)}>
                {type === 'text' && (
                    <Typography.Text className="mr-1 text-ink leading-5 whitespace-pre-wrap">
                        {displayContent}
                    </Typography.Text>
                )}

                {type === 'document' && mediaUrl && (
                    <Typography.Text className="mr-1 text-ink leading-5">
                        <a
                            target="_blank"
                            href={mediaUrl}
                        >
                            <Button icon={<FileOutlined />}>{t('View file')}</Button>
                        </a>
                    </Typography.Text>
                )}

                {type === 'image' && mediaUrl && (
                    <img
                        className="rounded-xl"
                        src={mediaUrl}
                    />
                )}

                {type === 'video' && mediaUrl && (
                    <video
                        controls
                        className="rounded-xl"
                    >
                        <source src={mediaUrl} />
                    </video>
                )}

                {type === 'audio' && mediaUrl && (
                    <audio
                        controls
                        className="rounded-xl"
                    >
                        <source src={mediaUrl} />
                    </audio>
                )}

                {createdAt && (
                    <>
                        <Typography.Text
                            className="text-[10px] min-h-[16px] block mt-1"
                            type="secondary"
                        >
                            <TimeAgo date={createdAt} />
                        </Typography.Text>
                    </>
                )}
            </div>
        </Flex>
    )
}
